import * as t from 'io-ts';

const temp = t.type({});

const scheduleSelf = t.type({
  id: t.string,
  href: t.string,
});

const dstvChannel = t.type({
  id: t.string,
  actualSchedules: t.array(t.type({})),
  genres: t.array(t.type({})),
  actualGenres: t.array(t.type({})),
  languageDescriptions: t.type({}),
  imageInstancesMap: t.type({}),
  videoAsset: t.string,
  bouquets: t.array(t.type({})),
});

const scheduleItem = t.type({
  id: t.string,
  self: scheduleSelf,
  eventId: t.string,
  epgEventId: t.string,
  mainContentID: t.string,
  mainGroupId: t.string,
  subGroupId: t.string,
  genref: t.union([t.undefined, t.string]),
  title: t.string,
  channelTag: t.string,
  associatedChannels: t.array(dstvChannel),
  shortSynopsis: t.string,
  longSynopsis: t.string,
  seasonNumber: t.number,
  episodeNumber: t.number,
  duration: t.string,
  episodeTitle: t.string,
  description: t.string,
  language: t.string,
  startDateTime: t.string,
  endDateTime: t.string,
  logLine: t.string,
  maturityClassification: t.string,
  starRating: t.string,
  associatedAd: t.boolean,
  associatedApplication: t.boolean,
  actors: t.array(t.type({})),
  actualActors: t.array(t.type({})),
  directors: t.array(t.type({})),
  actualDirectors: t.array(t.type({})),
  year: t.number,
  rating: t.string,
  dolbyDigital: t.boolean,
  subtitles: t.boolean,
  lastEpisodeFlag: t.boolean,
  series: t.boolean,
  special: t.boolean,
  contentFlag: t.string,
  macrovision: t.boolean,
  premierEvent: t.boolean,
  firstAiring: t.boolean,
  repeat: t.boolean,
  lastRepeat: t.boolean,
  liveEvent: t.boolean,
  delayedEvent: t.boolean,
  recommendations: t.boolean,
  highDefinition: t.boolean,
  widescreen: t.boolean,
  multipleSountracks: t.boolean,
  captions: t.boolean,
  socialTags: t.boolean,
  vidOnDemand: t.boolean,
  voDOnline: t.boolean,
  blockStream: t.boolean,
});

const tvGuideDStvApi = t.type({
  page: t.number,
  total: t.number,
  count: t.number,
  items: t.array(scheduleItem),
});

export const tvGuideDStvApiResponse = tvGuideDStvApi;
export type TvGuideDStv = t.TypeOf<typeof tvGuideDStvApiResponse>;

const channelItemStream = t.array(t.type({
  streamType: t.string,
  playerUrl: t.string,
  active: t.boolean,
}));

const channelItem = t.type({
  channelName: t.string,
  channelTag: t.string,
  channelNumber: t.string,
  streams: t.union([t.undefined, channelItemStream]),
});

const dstvCountryChannels = t.type({
  page: t.number,
  total: t.number,
  count: t.number,
  items: t.array(channelItem),
});

export const dstvCountryChannelsApiResponse = dstvCountryChannels;
